// Dictionaries
// fieldId constants
var USERNAME_SUFFIX = 'username';
var EMAIL_SUFFIX = 'email';
var CODE_SUFFIX = 'code';
var PHONE_SUFFIX = 'phone';
var PASSWORD_SUFFIX = 'password';
// Country Dial Code common constants
var COUNTRY_DIAL_CODE_SUFFIX = 'country-dial-code-select';
var COUNTRY_DIAL_CODE_DEFAULT = '+1';
// Auth Keys
var AUTH_SOURCE_KEY = 'amplify-auth-source';
var REDIRECTED_FROM_HOSTED_UI = 'amplify-redirected-from-hosted-ui';
var AUTHENTICATOR_AUTHSTATE = 'amplify-authenticator-authState';
// Error message Common Constants
var PHONE_EMPTY_ERROR_MESSAGE = 'Phone number can not be empty';
var NO_AUTH_MODULE_FOUND = 'No Auth module found, please ensure @aws-amplify/auth is imported';
var NO_STORAGE_MODULE_FOUND = 'No Storage module found, please ensure @aws-amplify/storage is imported';
// TOTP Messages
var SETUP_TOTP = 'SETUP_TOTP';
// Select MFA Types Messages
var USER_NOT_SETUP_SOFTWARE_TOKEN_MFA = 'User has not set up software token mfa';
var USER_NOT_VERIFIED_SOFTWARE_TOKEN_MFA = 'User has not verified software token mfa';
// Common events
var SUCCESS = 'SUCCESS';
// Hub Events and Channels
var AUTH_CHANNEL = 'auth';
var UI_AUTH_CHANNEL = 'UI Auth';
var TOAST_AUTH_ERROR_EVENT = 'ToastAuthError';
var AUTH_STATE_CHANGE_EVENT = 'AuthStateChange';
export { AUTH_CHANNEL as A, COUNTRY_DIAL_CODE_SUFFIX as C, EMAIL_SUFFIX as E, NO_AUTH_MODULE_FOUND as N, PHONE_EMPTY_ERROR_MESSAGE as P, REDIRECTED_FROM_HOSTED_UI as R, SETUP_TOTP as S, TOAST_AUTH_ERROR_EVENT as T, UI_AUTH_CHANNEL as U, AUTH_STATE_CHANGE_EVENT as a, PHONE_SUFFIX as b, AUTHENTICATOR_AUTHSTATE as c, NO_STORAGE_MODULE_FOUND as d, USER_NOT_SETUP_SOFTWARE_TOKEN_MFA as e, USER_NOT_VERIFIED_SOFTWARE_TOKEN_MFA as f, COUNTRY_DIAL_CODE_DEFAULT as g, SUCCESS as h, AUTH_SOURCE_KEY as i, CODE_SUFFIX as j, PASSWORD_SUFFIX as k, USERNAME_SUFFIX as l };
